<div class="card border-3 border-blue-500">
  <div *ngIf="chartSettings.dataSelected === undefined else elseBlock">

    <div class="flex justify-content-center flex-wrap">
      <div class="flex align-items-center justify-content-center"><p-progressSpinner></p-progressSpinner></div>
    </div>
  </div>

  <ng-template #elseBlock>
    <div class="grid">
      <div class="col-12">
        <p class="font-semibold text-center text-blue-500 text-4xl">Ventas diarias de {{monthTitle}}</p>
      </div>
      <div class="col-6 col-offset-6">
        <span>Seleccionar local:
          <p-dropdown
          [options]="keys"
          [(ngModel)]="selectedValue"
          placeholder="Seleccionar tipo de documento"
          [itemSize]="2"
          (onChange)="onSelectedBranchStore($event)"
        >
        </p-dropdown></span>

      </div>
      <div class="col-12">
          <ami-line-chart
          [dataSeries]="chartSettings.dataSelected"
          [categories]="chartSettings.categories"
          [x_title]="chartSettings.x_title"
          [y_title]="chartSettings.y_title"
          [formatter]="chartSettings.formatter"
          [chartTitle]="chartSettings.chartTitle"
        >
        </ami-line-chart>

        <!--

        <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [xaxis]="chartOptions.xaxis"
        [stroke]="chartOptions.stroke"
        [colors]="chartOptions.colors"
        [dataLabels]="chartOptions.dataLabels"
        [legend]="chartOptions.legend"
        [markers]="chartOptions.markers"
        [grid]="chartOptions.grid"
        [yaxis]="chartOptions.yaxis"
        [title]="chartOptions.title"
        [annotations]="chartOptions.annotations"
        [labels]="chartOptions.labels"
        ></apx-chart>     -->
      </div>
    </div>

  </ng-template>

</div>
